// extracted by mini-css-extract-plugin
export var cookiesSection = "d9_J6";
export var cookiesSection__btn = "d9_J9";
export var cookiesSection__link = "d9_J8";
export var cookiesSection__text = "d9_J7";
export var cookiesSection__wrapper = "d9_J5";